// Icons
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faGlobe,
  faPhone,
  faAngleDoubleUp,
  faAngleUp,
  faAngleDown,
  faAngleDoubleDown,
  faAngleLeft,
  faAngleRight,
  faEye,
  faEyeSlash,
  faLink,
  faUnlink,
  faInfoCircle,
  faComment,
  faTasks,
  faHome,
  faAddressBook,
  faClipboardList,
  faSlidersH,
  faUserFriends,
  faUser,
  faCross,
  faUserTie,
  faStar,
  faPlus,
  faMicrophone,
  faStop,
  faMinus,
  faEllipsisH,
  faCheckSquare,
  faPrint,
  faPaperPlane,
  faParagraph,
  faAlignCenter,
  faAlignRight,
  faAlignLeft,
  faAlignJustify,
  faGripLines,
  faGripVertical,
  faObjectGroup,
  faTableCellsLarge,
  faTableColumns,
  faTableList,
  faCaretSquareDown,
  faDotCircle,
  faStarHalfAlt,
  faClock,
  faCalendarAlt,
  faCalendarDay,
  faVoteYea,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faHighlighter,
  faHeading,
  faQuoteRight,
  faTable,
  faUndo,
  faRedo,
  faListUl,
  faListOl,
  faQuestionCircle,
  faExclamationCircle,
  faMoneyCheck,
  faArrowUpRightFromSquare,
  faPalette,
  faFont,
  faCode,
  faCopy,
  faSignature,
  faCheck,
  faTimes,
  faMagnifyingGlass,
  faLock,
  faLockOpen,
  faUpDownLeftRight,
  faSpinner,
  faPaperclip,
  faFile,
  faFilePdf,
  faFileExcel,
  faFileWord,
  faEnvelope,
  faSpellCheck,
  faWandMagicSparkles,
  faFileLines,
  faICursor,
  faImage,
  faCodeBranch,
  faCodeMerge,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  // Contact merge entry (contact danger zone)
  faCodeMerge,
  // Was never registered, so the editor's image button rendered blank.
  faImage,
  // AI text assistant (editor)
  faSpellCheck,
  faWandMagicSparkles,
  faFileLines,
  faICursor,
  faGlobe,
  faPhone,
  faAngleDoubleUp,
  faAngleUp,
  faAngleDown,
  faAngleDoubleDown,
  faAngleLeft,
  faAngleRight,
  faEye,
  faEyeSlash,
  faLink,
  faUnlink,
  faInfoCircle,
  faComment,
  faTasks,
  faHome,
  faAddressBook,
  faClipboardList,
  faSlidersH,
  faUserFriends,
  faUser,
  faCross,
  faUserTie,
  faStar,
  faPlus,
  faMicrophone,
  faStop,
  faMinus,
  faEllipsisH,
  faCheckSquare,
  faPrint,
  faPaperPlane,
  faParagraph,
  faAlignCenter,
  faAlignRight,
  faAlignLeft,
  faAlignJustify,
  faGripLines,
  faGripVertical,
  faObjectGroup,
  faTableCellsLarge,
  faTableColumns,
  faTableList,
  faCaretSquareDown,
  faDotCircle,
  faStarHalfAlt,
  faClock,
  faCalendarAlt,
  faCalendarDay,
  faVoteYea,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faHighlighter,
  faHeading,
  faQuoteRight,
  faTable,
  faUndo,
  faRedo,
  faListUl,
  faListOl,
  faQuestionCircle,
  faExclamationCircle,
  faMoneyCheck,
  faArrowUpRightFromSquare,
  faPalette,
  faFont,
  faCode,
  faCopy,
  faSignature,
  faCheck,
  faTimes,
  faMagnifyingGlass,
  faLock,
  faLockOpen,
  faUpDownLeftRight,
  faSpinner,
  faPaperclip,
  faFile,
  faFilePdf,
  faFileExcel,
  faFileWord,
  faEnvelope,
  faCodeBranch,
);

import {
  faStar as farStar,
  faTrashAlt,
  faCheckSquare as farCheckSquare,
  faSquare,
  faCheckCircle,
  faTimesCircle,
  faCircle,
  faDotCircle as farDotCircle,
  faCreditCard,
  faQuestionCircle as farQuestionCircle,
} from "@fortawesome/free-regular-svg-icons";

library.add(
  farStar,
  faTrashAlt,
  farCheckSquare,
  faSquare,
  faCheckCircle,
  faTimesCircle,
  faCircle,
  farDotCircle,
  faCreditCard,
  farQuestionCircle,
);

import { faCcVisa, faMicrosoft, faGoogle } from "@fortawesome/free-brands-svg-icons";
library.add(faCcVisa, faMicrosoft, faGoogle);

// Settings area (navigation, tables, dialogs)
import {
  faBuilding,
  faUserGroup,
  faAddressCard,
  faHashtag,
  faShieldHalved,
  faPlug,
  faFileImport,
  faChevronRight,
  faUserPlus,
  faUserMinus,
  faPen,
  faTrash,
  faUpload,
  faKey,
  faTriangleExclamation,
  faCircleInfo,
  faBoxArchive,
  faRightLeft,
  faHourglassHalf,
  faCircleXmark,
  faArrowRight,
  faXmark,
  faPowerOff,
  faRotate,
  faPlay,
  faArrowUp,
  faArrowDown,
  faCircleCheck,
  faCircleQuestion,
  faDoorOpen,
  faEuroSign,
  // Field palette of the form builder (Zusatzfelder): date and date-time fields.
  faCalendar,
  faCalendarPlus,
  // Mail module: connected mailboxes (navigation, IMAP provider, folders)
  faInbox,
  faServer,
  faFolder,
  // Meine Woche: nav entry, the orange "Heute" sun, the suggestions.
  faCalendarCheck,
  faSun,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faBuilding,
  faUserGroup,
  faAddressCard,
  faHashtag,
  faShieldHalved,
  faPlug,
  faFileImport,
  faChevronRight,
  faUserPlus,
  faUserMinus,
  faPen,
  faTrash,
  faUpload,
  faKey,
  faTriangleExclamation,
  faCircleInfo,
  faBoxArchive,
  faRightLeft,
  faHourglassHalf,
  faCircleXmark,
  faArrowRight,
  faXmark,
  faPowerOff,
  faRotate,
  faPlay,
  faArrowUp,
  faArrowDown,
  faCircleCheck,
  faCircleQuestion,
  faDoorOpen,
  faEuroSign,
  faCalendar,
  faCalendarPlus,
  faInbox,
  faServer,
  faFolder,
  faCalendarCheck,
  faSun,
  faLightbulb,
);
